import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=7e67ac8b&scoped=true"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=7e67ac8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e67ac8b",
  null
  
)

export default component.exports